import { useEffect, useState } from "react";
import { getBlogs } from "services";
import { Blog } from "types/blogs";
import { GetAllResponse } from "types/getAllResponse";

export const useBlogs = () => {
  const [blogs, setBlogs] = useState<GetAllResponse<Blog>>({
    count: 0,
    data: [],
  });

  useEffect(() => {
    Promise.all([getBlogs()]).then(([{ data: blogs }]) => {
      setBlogs(blogs);
    });
  }, []);

  return { blogs };
};
